export const PATH = {
    admin: '/',
    no_connection: '/no-connection',
    not_found: '/notfound',
    forbidden: '/forbidden',
    visma: '/visma/',
    distributor: '/distributor/',
    tasks: '/tasks/',
    visma_support: '/visma/support',
    visma_support_companies: '/visma/support/companies',
    distributor_support: '/distributor/support',
    distributor_support_companymove: '/distributor/support/companymove'
}
